export function AddAdminModalIcon({
  className = "size-6",
}: {
  className?: string;
}) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M2.97972 17.2613C3.16117 16.8233 3.2519 16.6043 3.3448 16.4075C4.76457 13.4004 7.72683 11.4212 11.0484 11.2605C11.2657 11.25 11.5089 11.25 11.9951 11.25C12.4814 11.25 12.7245 11.25 12.9418 11.2605C16.2634 11.4212 19.2257 13.4004 20.6454 16.4075C20.7383 16.6043 20.8291 16.8233 21.0105 17.2613C21.1354 17.5628 21.1979 17.7135 21.235 17.8286C21.8294 19.6702 20.5504 21.5845 18.6215 21.7403C18.5009 21.75 18.3378 21.75 18.0115 21.75H5.97877C5.65245 21.75 5.4893 21.75 5.36875 21.7403C3.43986 21.5845 2.16088 19.6702 2.75523 17.8286C2.79238 17.7135 2.85483 17.5628 2.97972 17.2613Z" fill="#101828" fill-opacity="0.18" />
      <path d="M8 6C8 3.79086 9.79086 2 12 2C14.2091 2 16 3.79086 16 6C16 8.20914 14.2091 10 12 10C9.79086 10 8 8.20914 8 6Z" fill="#101828" />
      <path d="M12 14.5V16.5M12 16.5V18.5M12 16.5H10M12 16.5H14" stroke="#101828" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
}
export const displayName = "AddAdminModalIcon";
